export default {
    getProcessTrackId(state) {
        return state.process_track_id;
    },

    getSteps(state) {
        return state.steps;
    },
}